module.exports = __webpack_public_path__ + "IO.png?1498d856f2c22cbc7709784d58bada9c";